export default __webpack_public_path__ + "static/media/git.4336ebd4.svg";